import Vue from 'vue'
import App from './App.vue'

import router from './router'

import store from './store'

import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'

import axios from './axios.js'

import '@/assets/css/main.css'

import './assets/scss/main.scss'

import FeatherIcon from './components/FeatherIcon.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const colors = {
  primary: '#7367F0',
  success: '#28C76F',
  danger: '#EA5455',
  warning: '#FF9F43',
  dark: '#1E1E1E'
}

Vue.use(Vuesax, { theme: { colors } })

// Feather font icon
require('./assets/css/iconfont.css')

Vue.prototype.$http = axios

Vue.prototype.$printError = function(error) {
  if (error.length === 0) return

  this.$vs.notify({
    title: 'Error',
    text: error,
    color: 'danger',
    iconPack: 'feather',
    icon: 'icon-alert-circle'
  })
}

Vue.prototype.$printSuccess = function(message) {
  this.$vs.notify({
    title: 'Success',
    text: message,
    color: 'success',
    iconPack: 'feather',
    icon: 'icon-check-circle'
  })
}

Vue.config.productionTip = false

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component(FeatherIcon.name, FeatherIcon)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
